import { Link } from "react-router-dom";
import { ArrowRight, Award, Snowflake, Truck } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function About() {
  const { settings } = useSettings();
  return (
    <div data-testid="about-page" className="bg-white">
      <div className="bg-[#0A192F] text-white">
        <div className="container-max px-4 md:px-8 py-20 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <div className="overline text-[#E9C46A] mb-3">Hakkımızda</div>
            <h1 className="font-display text-4xl md:text-6xl font-black tracking-tighter leading-none">
              {settings.about_title}
            </h1>
            <p className="mt-6 text-lg text-slate-200 max-w-xl leading-relaxed">
              {settings.about_content}
            </p>
          </div>
          <div className="rounded-3xl overflow-hidden aspect-[4/3]">
            <img src={settings.about_image_url} className="w-full h-full object-cover" alt="Çiftlik" />
          </div>
        </div>
      </div>

      <section className="section-pad">
        <div className="container-max grid md:grid-cols-3 gap-6">
          {[
            { icon: Award, title: "Üretici", text: "Kendi çiftliğimizden direkt üretim. Aracı yok, fiyatımız adil." },
            { icon: Snowflake, title: "Soğuk Zincir", text: "Hasattan otogara kesintisiz +2 / +4°C." },
            { icon: Truck, title: "Otobüs ile Hızlı", text: "Türkiye'nin tüm otogarlarına aynı gün gönderim." },
          ].map(({ icon: Icon, title, text }) => (
            <div key={title} className="bg-[#F4F7F9] rounded-2xl p-8 border border-slate-200">
              <Icon size={26} className="text-[#0077B6] mb-4" />
              <h3 className="font-display text-xl font-bold mb-2">{title}</h3>
              <p className="text-slate-600 text-sm leading-relaxed">{text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section-pad bg-[#F4F7F9]">
        <div className="container-max grid md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-7 rounded-3xl overflow-hidden aspect-[16/10]">
            <img src="https://images.pexels.com/photos/12762344/pexels-photo-12762344.jpeg" className="w-full h-full object-cover" alt="Deniz" />
          </div>
          <div className="md:col-span-5">
            <div className="overline mb-3">Hikayemiz</div>
            <h2 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight mb-4">
              Denizden gelen <span className="text-[#0077B6]">premium lezzet</span>
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Türkiye'nin temiz sularında yetiştirdiğimiz midyelerimizi günlük olarak hasat ediyor,
              özel olarak tasarlanmış soğuk zincir kargo paketlemesi ile size ulaştırıyoruz.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              Her partide gıda mühendislerimizin yaptığı kalite kontrol sayesinde, sofranıza
              gelen her midye birinci sınıf standardı taşır.
            </p>
            <Link to="/urunler" className="btn-primary">Ürünleri İncele <ArrowRight size={16} /></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
